module.exports = __webpack_public_path__ + "img/295.81cfbaee.png";